/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

export const toDisplayDate = (
  value: { readonly month: number; readonly year: number } | null | undefined
): Date | null => {
  if (!value) return null
  const { month, year } = value
  if (typeof month !== "number" || typeof year !== "number" || month < 1 || month > 12) {
    return null
  }
  return new Date(year, month - 1, 1)
}

/**
 * Number of simulated retirement start months: every month from the earliest
 * data month through December of the last allowed start year, inclusive.
 *
 * Returns null when `earliestDataDate` is not an "M/YYYY" string or the range
 * is empty, so callers show a placeholder instead of rendering NaN.
 */
export const countSimulationCohorts = (
  earliestDataDate: string,
  maxSimulationStartYear: number
): number | null => {
  const match = /^(\d{1,2})\/(\d{4})$/.exec(earliestDataDate)
  if (!match || !Number.isInteger(maxSimulationStartYear)) return null
  const month = Number(match[1])
  const year = Number(match[2])
  if (month < 1 || month > 12) return null
  const count = (maxSimulationStartYear - year) * 12 + (12 - month + 1)
  return count > 0 ? count : null
}
